<p-toast></p-toast>
<p-card>
    <ng-template pTemplate="header">
        <h5 class="pdfs-15">{{ 'NEW_ACCOUNT' | translate}}</h5>
    </ng-template>
    <div class="p-grid">
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt--15">{{ 'NAME_NEW_ACCOUNT' | translate}}</h5>
            <input autocomplete="off" type="username" class="inputfiled" placeholder="{{ 'NAME_NEW_ACCOUNT' | translate}}" pInputText [(ngModel)]="nombre" 
                [ngClass]="{'invalid': validarMensajeError('name')}" (input)="limpiarMensajeErrorForm('name')"/>
            <div class="error-message" *ngIf="validarMensajeError('name')">
                {{mensajeErrorForm.name}}
            </div>
        </div>
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt--15">{{ 'LAST_NAME' | translate}}</h5>
            <input autocomplete="off" type="username" class="inputfiled" placeholder="{{ 'LAST_NAME' | translate}}" pInputText [(ngModel)]="apellido" 
            [ngClass]="{'invalid': validarMensajeError('lastName')}" (input)="limpiarMensajeErrorForm('lastName')"/>
            <div class="error-message" *ngIf="validarMensajeError('lastName')">
                {{mensajeErrorForm.lastName}}
            </div>
        </div>
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt-15">{{ 'MAIL_NEW_ACCOUNT' | translate}}</h5>
            <input type="email" class="inputfiled" placeholder="{{ 'MAIL_NEW_ACCOUNT' | translate}}" pInputText [(ngModel)]="correo" 
            [ngClass]="{'invalid': validarMensajeError('email')}" (input)="limpiarMensajeErrorForm('email')"
            autocomplete="new-email" />
     
        
            <div class="error-message" *ngIf="validarMensajeError('email')">
                {{mensajeErrorForm.email}}
            </div>
        </div>
        
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt-15">{{ 'TYPE_NEW_ACCOUNT' | translate}}</h5>
            <p-selectButton [options]="roles" [(ngModel)]="account" class="selectCustom" optionLabel="name"
                optionValue="id" [ngClass]="{'invalid': validarMensajeError('idRol')}"></p-selectButton>
            <div class="error-message" *ngIf="validarMensajeError('idRol')">
                {{mensajeErrorForm.idRol}}
            </div>
        </div>
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mT-21">{{ 'PASSWORD_NEW_ACCOUNT' | translate}}</h5>
            <p-password [(ngModel)]="password" [feedback]="true" placeholder="Password" 
            [toggleMask]="true" [ngClass]="{'invalid': validarMensajeError('password')}" autocomplete="new-password">
</p-password>

        

            <div class="error-message" *ngIf="validarMensajeError('password')">
                {{mensajeErrorForm.password}}
            </div>
        </div>
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mT-21">{{ 'DEVICES_NEW_ACCOUNT' | translate}}</h5>
            <p-multiSelect [options]="suscriptions" [(ngModel)]="selectedDepart" defaultLabel="{{ 'DEVICES_NEW_ACCOUNT_LABEL' | translate}}"
                optionLabel="name" selectedItemsLabel="{0} departments selected"
                [style]="{'min-width':'100%'}" [ngClass]="{'invalid': validarMensajeError('idsSubscriptions')}"></p-multiSelect>
            <div class="error-message" *ngIf="validarMensajeError('idsSubscriptions')">
                {{mensajeErrorForm.idsSubscriptions}}
            </div>
        </div>

    </div>
    <div class="row mt-15">
        <button [disabled]="!(nombre && correo && account && password && selectedDepart) || cargando"
        pButton pRipple type="button" icon="pi pi-user" iconPos="right" (click)="addSingle()"
            label="{{ 'ADD_ACCOUNT_BTN' | translate}}" class="p-button-raised p-button-success fR">
        </button>
    </div>
    <ng-template pTemplate="footer">

    </ng-template>
</p-card>